import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ArrowNext = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.99 11.9975C21.99 11.8277 21.92 11.6678 21.8001 11.5579L13.0545 3.17493C12.8046 2.93513 12.4148 2.94512 12.1749 3.18492C11.935 3.42472 11.945 3.8144 12.1849 4.05419L19.8211 11.3781H2.61969C2.27986 11.3781 2 11.6578 2 11.9975C2 12.3373 2.27986 12.617 2.61969 12.617H19.8211L12.1849 19.9409C11.935 20.1807 11.935 20.5704 12.1749 20.8102C12.2949 20.9301 12.4648 21 12.6247 21C12.7846 21 12.9345 20.9401 13.0645 20.8301L21.8101 12.4572C21.92 12.3373 22 12.1874 22 12.0175L21.99 11.9975Z" />
  </svg>
)

export default withDefaultStyles(ArrowNext)
